import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import moment from 'moment';
import { format, isValid } from 'date-fns';

import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import Select, { components } from 'react-select';


import Input from '../../components/Input/Input';
import { createVacations, updateVacations } from '../../store/actions/vacation';

const styles = () => ({
  paperWidth: {
    padding: '10px 0',
    width: '750px',
    maxWidth: '750px',
  },
});

export class AllowanceDialog extends React.Component {
  state = {
    vacation: {
      dtFrom: null,
      dtTo: null,
      category: '',
      observation: null,
      compensationDate: null,
      allowanceHours: '',
      expectedRule: ''
    },
    legendaData: 'Início do periodo',
    reduces: '',
    homeOffice: '',
    customOption: '',
    selectedOption: null,
    buttonConfirm: false
  };

  handleOptionChange = (selected) => {
    this.setState({ selectedOption: selected });
    this.setState({ customOption: '' });
  };

  handleCustomOptionChange = (event) => {
    const { value } = event.target;
    this.setState({ customOption: value });
    this.setState({ selectedOption: null });
  };


  formatCompensation = (date) => {
    const formattedDate = new Date(date);
    formattedDate.setHours(0);
    formattedDate.setMinutes(0);
    formattedDate.setSeconds(0);

    return formattedDate;
  }

  handleInputChange = (event, type) => {
    const newVacation = { ...this.state.vacation };


    switch (type) {
      case 'category':
        if (event.target.value == 'JUST_ABS' ||
          event.target.value == 'OPTIONAL_DAY' ||
          event.target.value == 'WORK_LEAVE' ||
          event.target.value == 'LEAVE_OF_ABSENCE' ||
          event.target.value == 'OUT_JUST_ABSENCE' ||
          event.target.value == 'BANK_HOURS_COMPENSATION' ||
          event.target.value == 'HOME_OFFICE' ||
          event.target.value == 'VACATION'
        ) {
          newVacation.observation = null;
          newVacation.dtFrom = null
          newVacation.dtTo = null
          this.setState({ allowanceHours: null, compensationDate: null, reduces: '', homeOffice: '', vacation: newVacation })
        } else {
          newVacation.observation = null;
          newVacation.dtFrom = null
          newVacation.dtTo = null
          this.setState({ allowanceHours: null, compensationDate: null, reduces: '', homeOffice: '', vacation: newVacation })
        }

        newVacation.category = event.target.value;
        this.setState({ vacation: newVacation });
        break;

      case 'observation':
        newVacation.observation = event.target.value;
        this.setState({ vacation: newVacation, });
        break;

      case 'dtFrom':
        // newVacation.dtFrom = dateFns.format(event, 'yyyy-MM-dd');
        newVacation.dtFrom = event;
        if (this.state.vacation.category == 'CHANGE_DAY') {
          newVacation.dtTo = event
        }
        this.setState({ vacation: newVacation });
        break;

      case 'dtTo':
        // newVacation.dtTo = dateFns.format(event, 'yyyy-MM-dd');
        newVacation.dtTo = event;
        newVacation.compensationDate = this.formatCompensation(event);
        this.setState({ vacation: newVacation, buttonConfirm: true });
        break;

      case 'compensationDate':
        // newVacation.compensationDate = dateFns.format(event, 'yyyy-MM-dd');
        newVacation.compensationDate = this.formatCompensation(event);
        this.setState({ vacation: newVacation, buttonConfirm: true });
        break;

      case 'allowanceHours':
        newVacation.allowanceHours = event;
        this.setState({ vacation: newVacation, buttonConfirm: true });
        break;

      default:
        break;
    }
  };

  handleCreateSubmit = () => {
    const vacationDate = { ...this.state.vacation };
    vacationDate.dtTo = this.state.vacation.dtFrom;
    const newVacation = { ...this.state.vacation };
    newVacation.employees = this.props.employees;
    newVacation.allowanceHours = this.state.vacation.allowanceHours == '' ? null : moment.duration(format(this.state.vacation.allowanceHours, 'HH:mm')).asMinutes();
    if ((newVacation.dtTo === '' || newVacation.dtTo === null) && newVacation.category === 'ALLOWANCE_HOURS' || newVacation.category === 'JUSTIFIED_DELAY' || this.state.vacation.category === 'MISSING_TIME' || this.state.vacation.category === 'OUTPUT_SERVICE') {
      newVacation.dtTo = this.state.vacation.dtFrom;

      if (isValid(newVacation.dtTo)) {
        newVacation.dtTo = format(newVacation.dtTo, 'yyyy-MM-dd');
      }

      if (isValid(newVacation.dtFrom)) {
        newVacation.dtFrom = format(newVacation.dtFrom, 'yyyy-MM-dd');
      }

      newVacation.allowanceHours = moment.duration(format(this.state.vacation.allowanceHours, 'HH:mm')).asMinutes();
      if (this.state.vacation.category === 'MISSING_TIME') {
        newVacation.expectedRule = 'MISSING_TIME'
      } else {
        newVacation.expectedRule = 'REDUCE_EXPECTED_WORKING'
      }
      this.props.onCreateVacations(newVacation);

    } else {
      if (isValid(newVacation.dtTo)) {
        newVacation.dtTo = format(newVacation.dtTo, 'yyyy-MM-dd');
      }

      if (isValid(newVacation.dtFrom)) {
        newVacation.dtFrom = format(newVacation.dtFrom, 'yyyy-MM-dd');
      }
      if (this.state.vacation.category === 'VACATION' ||
        this.state.vacation.category === 'JUST_ABS' ||
        this.state.vacation.category === 'OPTIONAL_DAY' ||
        this.state.vacation.category === 'WORK_LEAVE' ||
        this.state.vacation.category === 'LEAVE_OF_ABSENCE' ||
        this.state.vacation.category === 'INTERJOURNEY_PER_DAY'
      ) {
        newVacation.expectedRule = null
      }
      else if (this.state.vacation.category === 'SUNDAY_OR_HOLIDAY_COMPENSATION') {
        newVacation.expectedRule = 'COMP_SUN_FRD'
      }
      else if (this.state.vacation.category === 'CHANGE_DAY') {
        newVacation.expectedRule = 'CHANGE_DAY'
        // newVacation.dtTo = format(newVacation.dtFrom, 'yyyy-MM-dd');
        // newVacation.dtFrom = format(newVacation.dtFrom, 'yyyy-MM-dd');
        // newVacation.compensationDate = newVacation.dtTo
      }
      else if (this.state.vacation.category === 'OUT_JUST_ABSENCE') {
        newVacation.expectedRule = 'OUT_JUST_ABSENCE'
      }
      else if (this.state.vacation.category === 'BANK_HOURS_COMPENSATION') {
        newVacation.expectedRule = 'REDUCE_BANK_HOURS'
      }
      else if (this.state.vacation.category === 'DECLARATION_ATTENDANCE') {
        newVacation.expectedRule = this.state.reduces
      }
      else if (this.state.vacation.category === 'HOME_OFFICE') {
        newVacation.expectedRule = this.state.homeOffice
      }

      this.props.onCreateVacations(newVacation);
    }
  };

  handleClose = () => {
    const {
      title,
    } = this.props;

    if (title === 'Cadastrar') {
      this.props.onClose();
      const newVacation = {
        dtFrom: null,
        dtTo: null,
        category: '',
        observation: '',
        compensationDate: '',
        allowenceHours: '',
      };
      this.setState({ vacation: newVacation });
    }
  }

  handleConfirmAction = () => {
    const { vacation } = this.state;
    const {
      selected, title, editField, onClose,
    } = this.props;

    if (title === 'Cadastrar') {
      this.handleCreateSubmit();
      this.props.onClose();
      const newVacation = {
        dtFrom: null,
        dtTo: null,
        category: '',
        observation: '',
        compensationDate: '',
        allowenceHours: '',
      };
      this.setState({ vacation: newVacation });

      this.props.history.push('/abonos');
    } else {
      switch (editField) {
        case 'Período':
          this.props.onUpdateVacations({
            ids: selected,
            dtFrom: vacation.dtFrom,
            dtTo: vacation.dtTo,
            compensationDate: vacation.compensationDate,
            allowanceHours: vacation.allowanceHours,
          });
          onClose();
          break;

        case 'Observação':
          this.props.onUpdateVacations({ ids: selected, observation: vacation.observation, compensationDate: vacation.compensationDate });
          onClose();
          break;

        case 'Tipo':
          this.props.onUpdateVacations({ ids: selected, category: vacation.category, compensationDate: vacation.compensationDate });
          onClose();
          break;

        default:
          break;
      }
    }
  };

  renderNoneSelected = () => (
    <React.Fragment>
      <DialogTitle>Selecionar um funcionário</DialogTitle>
      <DialogContent>
        <DialogContentText>
          Selecione no minimo um funcionário para adicionar um abono
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={this.props.onClose}>CANCELAR</Button>
        <Button type="submit" variant="contained" color="primary" onClick={this.props.onClose}>
          OK
        </Button>
      </DialogActions>
    </React.Fragment>
  );

  renderPeriodField = () => (
    <React.Fragment>
      {this.props.title === 'Cadastrar' ? <DialogContentText>PERÍODO</DialogContentText> : null}
      {/* { this.state.vacation.category === 'SUNDAY_OR_HOLIDAY_COMPENSATION' ? this.setState({ legendaData: 'Dia de folga' }) : this.state.legendaData } */}
      {this.state.vacation.category === 'SUNDAY_OR_HOLIDAY_COMPENSATION'
        ? <div className="picker">
          <Input
            elementType="datePicker"
            style={{ marginRight: '40px' }}
            label="Dia de folga"
            margin="normal"
            value={this.state.vacation.dtFrom}
            onChange={event => this.handleInputChange(event, 'dtFrom')}
          />
          <Input
            elementType="datePicker"
            label="Domingo/feriado trabalhado"
            margin="normal"
            value={this.state.vacation.compensationDate || null}
            onChange={event => this.handleInputChange(event, 'compensationDate')}
          />
        </div>
        : this.state.vacation.category === 'ALLOWANCE_HOURS' || this.state.vacation.category === 'JUSTIFIED_DELAY' || this.state.vacation.category === 'MISSING_TIME' || this.state.vacation.category === 'OUTPUT_SERVICE' || this.state.vacation.category === 'DECLARATION_ATTENDANCE' ?
          <div className="picker" style={{ display: 'flex' }}>
            <Input
              elementType="datePicker"
              label="Início do período"
              style={{ marginRight: '40px' }}
              margin="normal"
              value={this.state.vacation.dtFrom}
              onChange={event => this.handleInputChange(event, 'dtFrom')}
            />
            {
              this.state.vacation.category === 'DECLARATION_ATTENDANCE' ?
                <>

                  <Input
                    elementType="datePicker"
                    label="Fim do período"
                    style={{ marginRight: '40px' }}
                    margin="normal"
                    value={this.state.vacation.dtTo}
                    onChange={event => this.handleInputChange(event, 'dtTo')}
                  />
                </>
                : null
            }
            <Input
              elementType="timePicker"
              style={{ marginRight: '40px' }}
              label={this.state.vacation.category == "MISSING_TIME" ? "Hora falta" : "Horas abonadas"}
              margin="normal"
              value={this.state.vacation.allowanceHours || null}
              onChange={event => this.handleInputChange(event, 'allowanceHours')}
            />


          </div> : (
            <div className="picker" >
              <Input
                elementType="datePicker"
                style={{ marginRight: '40px' }}
                label={this.state.vacation.category == "CHANGE_DAY" ? "Dia trabalhado" : this.state.legendaData}
                margin="normal"
                value={this.state.vacation.dtFrom}
                onChange={event => this.handleInputChange(event, 'dtFrom')}
              />
              <Input
                elementType="datePicker"
                label={this.state.vacation.category == "CHANGE_DAY" ? "Dia da folga" : "Fim do período"}
                margin="normal"
                value={this.state.vacation.category == "CHANGE_DAY" ? this.state.vacation.compensationDate : this.state.vacation.dtTo}
                onChange={event => this.handleInputChange(event, this.state.vacation.category == "CHANGE_DAY" ? 'compensationDate' : 'dtTo')}
              />
            </div>)
      }
    </React.Fragment>
  );


  render() {
    const {
      classes, open, onClose, title, editField, employees,
    } = this.props;
    const { vacation } = this.state;

    const types = [
      { value: 'VACATION', displayValue: 'FÉRIAS' },
      { value: 'JUST_ABS', displayValue: 'FALTAS JUSTIFICADAS' },
      { value: 'OPTIONAL_DAY', displayValue: 'PONTO FACULTATIVO' },
      // { value: 'WORK_LEAVE', displayValue: ' DIA DE FOLGA' },
      { value: 'LEAVE_OF_ABSENCE', displayValue: 'LICENÇA/AFASTAMENTO' },
      { value: 'SUNDAY_OR_HOLIDAY_COMPENSATION', displayValue: 'COMPENSAÇÃO DE DOMINGO/FERIADO' },
      { value: 'ALLOWANCE_HOURS', displayValue: 'ABONO DE HORAS' },
      { value: 'OUT_JUST_ABSENCE', displayValue: 'FALTA SEM JUSTIFICATIVA' },
      { value: 'JUSTIFIED_DELAY', displayValue: 'ATRASO JUSTIFICADO' },
      { value: 'OUTPUT_SERVICE', displayValue: 'SAIDA Á SERVIÇO' },
      { value: 'DECLARATION_ATTENDANCE', displayValue: 'DECLARAÇÃO DE COMPARECIMENTO' },
      { value: 'BANK_HOURS_COMPENSATION', displayValue: 'COMPENSAR NO BANCO DE HORAS' },
      { value: 'MISSING_TIME', displayValue: 'HORA FALTA' },
      { value: 'HOME_OFFICE', displayValue: 'HOME OFFICE' }, // TOTAL_WORKING_EQUAL_EXPECTED OU NONE carga horario igual ao esperado ou contabilizar ponto normalmente
      { value: 'CHANGE_DAY', displayValue: 'TROCA DE FOLGA' }, // TOTAL_WORKING_EQUAL_EXPECTED OU NONE carga horario igual ao esperado ou contabilizar ponto normalmente
      { value: 'INTERJOURNEY_PER_DAY', displayValue: 'INTERJORNADA POR DIA' }
    ];

    const typesReduce = [
      { value: 'REDUCE_EXPECTED_WORKING', displayValue: 'Abonar horas' },
      { value: 'REDUCE_BANK_HOURS', displayValue: 'Compensar no banco de horas ' }
    ]

    const typesHome = [
      { value: 'TOTAL_WORKING_EQUAL_EXPECTED', displayValue: 'Carga horária conforme escala de trabalho atual' },
      { value: 'NONE', displayValue: 'Carga horária pré-assinalada da escala de trabalho atual' }
    ]

    const observations = [
      { value: 'AFASTAMENTO PELO INSS', displayValue: 'AFASTAMENTO PELO INSS' },
      { value: 'LICENÇA MATERNIDADE', displayValue: 'LICENÇA MATERNIDADE' },
      { value: 'ATESTADO MÉDICO', displayValue: 'ATESTADO MÉDICO' },
      { value: 'DECLARAÇÃO DE ÓBITO', displayValue: 'DECLARAÇÃO DE ÓBITO' },
      { value: 'LICENÇA PATERNIDADE', displayValue: 'LICENÇA PATERNIDADE' },
      { value: 'LICENÇA POR CASAMENTO', displayValue: 'LICENÇA POR CASAMENTO' },
      { value: 'LICENÇA AMAMENTAÇÃO', displayValue: 'LICENÇA AMAMENTAÇÃO' },
      // { value: 'outro', label: 'outro' }
    ]

    const customOptionValue = { value: this.state.customOption, label: this.state.customOption };

    const handleCreateCustomOption = () => {
      if (this.state.customOption) {
        this.setState({ selectedOption: customOptionValue });
      }
    };
    const customStyles = {
      control: (provided) => ({
        ...provided,
        minHeight: 'unset',
        height: 'auto',
        border: '1px solid #ccc',
        borderRadius: '4px',
        boxShadow: 'none',
      }),
      option: (provided) => ({
        ...provided,
        fontSize: '14px',
        padding: '8px',
      }),
    };

    return (
      <React.Fragment>
        <Dialog
          open={open}
          onClose={onClose}
          PaperProps={{ classes: { root: classes.paperWidth } }}
        >
          {employees && employees.length === 0 ? this.renderNoneSelected() : (
            <React.Fragment>
              <DialogTitle>
                {title === 'Cadastrar' ? 'Cadastrar abono' : 'Editar abonos'}
              </DialogTitle>

              <DialogContent>
                <DialogContentText>
                  {title === 'Cadastrar'
                    ? 'Informe os dados para cadastro de férias, folgas, faltas justificadas ou licenças'
                    : `Atualize o(a) ${editField} das férias, folgas, faltas justificadas ou licenças selecionadas`}
                </DialogContentText>
                {title === 'Cadastrar' || editField === 'Tipo' ? (
                  <div style={{ width: '400px' }}>
                    <Input
                      elementType="select"
                      value={vacation.category ? vacation.category : ''}
                      onChange={event => {
                        this.handleInputChange(event, 'category')
                        if (event.target.value == 'LEAVE_OF_ABSENCE') {
                          this.setState({ observation: false })
                        }
                      }}
                      label="Tipo"
                      options={types}
                      margin="normal"
                      required
                      fullWidth
                    />
                  </div>
                ) : null}
                <div>
                  {title === 'Cadastrar' || editField === 'Observação' ? (
                    <div style={{ width: '400px' }}>
                      {
                        this.state.vacation.category === 'LEAVE_OF_ABSENCE' ? '' :
                          <Input
                            elementType="input"
                            value={vacation.observation ? vacation.observation : null}
                            onChange={event => this.handleInputChange(event, 'observation')}
                            type="text"
                            label="Observação"
                            margin="normal"
                            fullWidth
                          />
                      }
                    </div>

                  ) : null}
                  {
                    this.state.vacation.category === 'DECLARATION_ATTENDANCE' ?

                      <div style={{ width: '400px' }}>
                        <Input
                          elementType="select"
                          value={this.state.reduces}
                          onChange={event => {
                            this.setState({ reduces: event.target.value })
                          }
                          }
                          label="De onde compensar?"
                          options={typesReduce}
                          margin="normal"
                          required
                          fullWidth
                        />
                      </div> : ''
                  }
                  {
                    this.state.vacation.category === 'HOME_OFFICE' ?

                      <div style={{ width: '400px' }}>
                        <Input
                          elementType="select"
                          value={this.state.homeOffice}
                          onChange={event => {
                            this.setState({ homeOffice: event.target.value })
                          }}
                          label="Escolher carga horária"
                          options={typesHome}
                          margin="normal"
                          required
                          fullWidth
                        />
                      </div> : ''
                  }

                  {
                    this.state.vacation.category === 'LEAVE_OF_ABSENCE' ?

                      <div style={{ width: '400px' }}>

                        <Input
                          elementType="select"
                          value={this.state.valueObservation}
                          onChange={event => {
                            if (event.target.value == 'outro') {
                              this.setState({ observation: true })
                            } else {
                              this.handleInputChange(event, 'observation')
                              this.setState({ valueObservation: event.target.value })
                              this.setState({ observation: false })
                            }
                          }}
                          label="Observação"
                          options={observations}
                          margin="normal"
                          fullWidth
                        >
                        </Input>

                      </div> : ''
                  }
                </div>

                {title === 'Cadastrar' || editField === 'Período' ? this.renderPeriodField() : null}
              </DialogContent>

              <DialogActions>
                <Button onClick={onClose}>CANCELAR</Button>
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  onClick={this.handleConfirmAction}
                  disabled={!this.state.buttonConfirm}
                >
                  CONFIRMAR
                </Button>
              </DialogActions>
            </React.Fragment>
          )}
        </Dialog>
      </React.Fragment>
    );
  }
}

AllowanceDialog.propTypes = {
  employees: PropTypes.array,
  open: PropTypes.bool,
  editField: PropTypes.string,
  selected: PropTypes.array,
  title: PropTypes.string.isRequired,
  classes: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
  onCreateVacations: PropTypes.func.isRequired,
  onUpdateVacations: PropTypes.func.isRequired,
};

AllowanceDialog.defaultProps = {
  open: false,
  employees: undefined,
  editField: '',
  selected: [],
};

const mapStateToProps = state => ({
  loading: state.general.loading,
});

const mapDispatchToProps = dispatch => ({
  onCreateVacations: vacation => dispatch(createVacations(vacation)),
  onUpdateVacations: vacation => dispatch(updateVacations(vacation)),
});

export const StyledComponent = withStyles(styles)(AllowanceDialog);

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps,
)(StyledComponent));
